import { FileDocumentRemoveOutlineIcon } from './FileDocumentRemoveOutlineIcon';

/**
 * author: Simran
 * id 9125073F-13EB-4FAD-AE78-30E02AC5B906
 * name file-document-remove-outline
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-document-remove-outline.svg
 * tags
 * - Files / Folders 
 */
export const FileTextRemoveOutlineIcon = FileDocumentRemoveOutlineIcon;
export default FileTextRemoveOutlineIcon